<div>
  <div class="error" *ngIf="showError">Unfortunately, the AI is out of capacity. We are working on it!</div>

  <div class="d-flex justify-content-end mb-1" *ngIf="!showError">
    <div class="toolbar py-1 px-3 float-right">
      <!-- <img src="./assets/img/play_icon_disabled.svg" title="Play" /> -->
      <img src="./assets/img/copy_icon.svg" title="Copy to clipboard" (click)="copyTableAsHtml()" class="ml-3 cursor-pointer" />
      <div class="menu-btn ml-3 d-inline-block" [matMenuTriggerFor]="menu" (click)="accordion.openAll()">
        <img src="./assets/img/open_slides_blue_icon.svg" title="Download as" />
        <span type='button' class="text-primary mx-2">Export</span>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="exportAsPdf()" [disabled]="false"><img src="./assets/img/pdf_icon.svg" title="Download as PDF" class="mr-3" />Download as PDF</button>
          <button mat-menu-item [disabled]="true" matTooltip="Coming soon"><img src="./assets/img/open_disabled_icon.svg" title="Open in Slides" class="mr-3" />Open in Google Slides</button>
        </mat-menu>
        <img src="./assets/img/down_arrow.svg" title="Download as" />
      </div>
    </div>
  </div>

  <mat-accordion *ngIf="!showError" multi id="downloadableContent">
    <mat-expansion-panel *ngFor="let key of agendaKeys" class="mb-2">
      <mat-expansion-panel-header>
        <div class="header-left">
          <div class="day">Day</div>
          <div class="day-num">{{key}}</div>
        </div>
        <div class="vertical-line"></div>
        <div class="header-middle">
          <div>
            <mat-icon>schedule</mat-icon>
          </div>
          <div class="timeline">{{calcStartAndEndDates(agendaTasks[key])}}</div>
        </div>
      </mat-expansion-panel-header>
      <table #tableElement class="table">
        <thead>
          <tr>
            <th class="col-2 text-center align-middle">Time</th>
            <th class="col-4 align-middle">Title</th>
            <th class="col-6">Activities</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let task of agendaTasks[key]">
            <td class="col-2 text-center align-middle">{{ calcTime(task.time) }}</td>
            <td class="col-4 align-middle">{{ task.title }}</td>
            <td class="col-6">
              <ul class="list-group">
                <li class="list-group-item" *ngFor="let activity of task.activities">{{ activity }}</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </mat-expansion-panel>
  </mat-accordion>
  <div *ngIf="showDiscrapancy" class="d-flex flex-row">
    <div class="p-1 disclaimer">*</div>
    <div class="p-1 disclaimer">Discrepancies between the "Workshop hours per day" value and the number of hours above
      might occur due to the Gen AI model optimizing the duration of the workshop,
      based on the "Topic Description".
      <!-- Changes can be made manually in the downloaded PowerPoint. --></div>
  </div>
</div>